export default __webpack_public_path__ + "static/media/english-to-hindi-screenshot-03.52029eb7.png";